/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../../config/axios";
import { URL_API } from "../../../config/default";
import Error from "../../Error/Index";
import ReviewsOverview from "../../../components/Admin/reviews-overview";

const Info = () => {
  const [filter, setFilter] = useState({});


  const { isPending: isPendingStatistics, data: statistics } = useQuery({
    queryKey: ["statistics", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);

      return fetch(`${URL_API}/reviews/statistics`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  const { isPending: isPendingReviews, data: reviews } = useQuery({
    queryKey: ["reviews", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams(filter);

      return fetch(`${URL_API}/reviews?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  const {
    isPending,
    error,
    data: list,
  } = useQuery({
    queryKey: ["list-properties", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);

      return fetch(`${URL_API}/properties/list`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending || isPendingReviews || isPendingStatistics) return "";

  if (error) return <Error />;

  /*
  
  return (
    <div className="mx-auto md:w-[80%] w-full py-5 min-h-screen">
      <span className="text-primary font-bold text-2xl block mb-4">Info</span>
      <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <ul
          className="w-full flex justify-start p-0 text-sm font-medium text-center border-0"
          id="default-tab"
          data-tabs-toggle="#default-tab-content"
          role="tablist"
        >
          <li className="me-2 p-0" role="presentation">
            <button
              className={
                select == 0
                  ? "font-bold border border-black border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
                  : "border border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
              }
              id="profile-tab"
              data-tabs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              onClick={() => setSelect(0)}
            >
              Evaluaciones
            </button>
          </li>
          <li className="me-2" role="presentation">
            <button
              className={
                select == 1
                  ? "font-bold border border-black border-t-0 border-s-0 border-e-0 inline-block p-2 w-full border-b-2 rounded-t-lg"
                  : "border border-t-0 border-s-0 border-e-0 inline-block p-2 w-full border-b-2 rounded-t-lg"
              }
              id="dashboard-tab"
              data-tabs-target="#dashboard"
              type="button"
              role="tab"
              aria-controls="dashboard"
              aria-selected="false"
              onClick={() => setSelect(1)}
            >
              Ganancias
            </button>
          </li>
          <li className="me-2" role="presentation">
            <button
              className={
                select == 2
                  ? "font-bold border border-black border-t-0 border-s-0 border-e-0 inline-block p-2 w-full border-b-2 rounded-t-lg"
                  : "border border-t-0 border-s-0 border-e-0 inline-block p-2 w-full border-b-2 rounded-t-lg"
              }
              id="settings-tab"
              data-tabs-target="#settings"
              type="button"
              role="tab"
              aria-controls="settings"
              aria-selected="false"
              onClick={() => setSelect(2)}
            >
              Vistas
            </button>
          </li>
        </ul>
      </div>
      <div id="default-tab-content">{tab(list)}</div>
    </div>
  );
  */

  console.log(reviews);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Info</h1>
        <p className="text-gray-600 mt-2">
          Gestión de evaluaciones y comentarios de alojamientos
        </p>
      </div>

      <ReviewsOverview
        statistics={statistics}
        data={reviews}
        properties={list}
        setFilter={setFilter}
        filter={filter}
      />
    </div>
  );
};

export default Info;
